module.exports = __webpack_public_path__ + "img/yl.d1f159a5.png";